import { ComponentOptions } from 'vue';
import { KVComponent } from 'types';

interface KeysData extends KVComponent {}

export default {
  props: ['list', 'noKeys', 'visible'],
} as ComponentOptions<KeysData>;
